import HeroSection from "../../components/heroSection";
import Navbar from "../../components/navbar";
import shareGoodness from "../../assets/images/share-goodness-illustration.svg";
import resourcesIllustration from "../../assets/images/resources-illustration.svg";
import Button from "../../components/button";
import youtubeIcon from "../../assets/icons/youtubePlay.svg";
import aiImage from "../../assets/images/zaynab-mariam.svg";
import play from "../../assets/icons/play.svg";
import add from "../../assets/icons/whiteAddCampaignIcon.svg"
import Accordion from "../../components/faq";
import tvShowThumbnail from "../../assets/images/Aminah.jpg";
import streetwise from "../../assets/images/Streetwise-Muslim.png";
import Footer from "../../components/footer";
import RecommendedCampaigns from "../Campaigns/reuseableComponents/recommendedCampaigns";
import { useTotalAmount } from "../reuseableEffects";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import CompletedCampaignSummary from "../Campaigns/completedCampaignsSummary";
import { useState } from "react";

const Landing = () => {

  const loading = useSelector((state) => state.user.loading);
  document.title = `${loading? "Mosquepay" : "Welcome to Mosquepay - Your home for collective giving and receiving."}`


  const navigate = useNavigate();

  const saveCreateCampaignClick = () => {
    navigate("/sign-in", { state: { actionType: "createCampaign" } });
  };

 const Stats = useTotalAmount()
 const totalAmountRaised = Stats[0]?.amount
 const totalDonations = Stats[0]?.txn_counts

  const [isModalOpen, setIsModalOpen] = useState(false);
  const videoThumbnail = "https://img.youtube.com/vi/ErheTfLZuyM/maxresdefault.jpg";
  
  const openModal = () => {
    setIsModalOpen(true);
  };
  
  const closeModal = () => {
    setIsModalOpen(false);
  };
  
  // Extract video ID from YouTube URL
  const getYouTubeEmbedUrl = (url) => {
    const videoId = url.split('v=')[1]?.split('&')[0];
    return `https://www.youtube.com/embed/${videoId}?autoplay=1&controls=1`;
  };

    return (
      <div className="grid gap-10">
        <div>
          <Navbar />
          <HeroSection />
        </div>

        <RecommendedCampaigns />
        <CompletedCampaignSummary />

        {/* Embrace the power of Sadaqah */}
        <div className="px-4 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-4 items-center">
          <div>
            <img src={shareGoodness} alt="" />
          </div>
          <div className="lg:px-10 text-pretty text-center lg:text-start">
            <p className=" font-bold text-2xl capitalize mb-3 ubuntu-font">
              Embrace the Power of Sadaqah.
            </p>
            <p>
              Giving in Islam is a profound way to express faith and compassion,
              transforming lives and uplifting communities. Through Sadaqah
              (voluntary charity), we fulfill a sacred duty, earn divine
              blessings, support those in need, and strengthen the Ummah
              (community).
              <br /> <br />
              Every donation, big or small, makes a significant impact. Your
              generosity is a beacon of hope and unity. Together, let’s embrace
              the spirit of giving and create lasting change.
              <br />
              <br />
              Give Today, Change Lives.
            </p>
          </div>
        </div>

        {/* Articles / resources */}
        <div className="px-4 md:px-12 grid grid-cols-1 lg:grid-cols-3 gap-4">
          <div className="bg-secondaryBackground grid content-between">
            <div>
              <div className="p-1">
                <img
                  src={resourcesIllustration}
                  alt=""
                  className="rounded-t w-full"
                />
              </div>
              <div className="px-4 pt-4">
                <span className="text-secondary font-semibold text-xs mb-4">
                  #Entertainment
                </span>
                <p>
                  Streetwise Muslims is designed to engage and educate Muslims
                  to rekindle and scale their Islamic knowledge.
                </p>
              </div>
            </div>
            <div className="p-4 flex">
              <Button
                buttonText={"Watch episodes"}
                otherStyles={"bg-black text-white"}
                buttonRole={"link"}
                destination={"https://www.youtube.com/playlist?list=PLBDpImb7W8w7whGrzRgAOJsTPrzR01vFa"}
                icon={youtubeIcon}
              />
            </div>
          </div>
          <div className="bg-secondaryBackground grid content-between">
            <div>
              <div className="p-1">
                <img
                  src={resourcesIllustration}
                  alt=""
                  className="rounded-t w-full"
                />
              </div>
              <div className="px-4 pt-4">
                <span className="text-secondary font-semibold text-xs mb-4">
                  #HelpAndSupport
                </span>
                <p>
                  How to start a fundraiser and reach your campaign goals with
                  Mosquepay.
                </p>
              </div>
            </div>
            <div className="p-4 flex">
              <Button
                buttonText={"Watch episodes"}
                otherStyles={"bg-black text-white"}
                buttonRole={"link"}
                destination={"/"}
                icon={youtubeIcon}
              />
            </div>
          </div>
          <div className="bg-secondaryBackground grid content-between">
            <div>
              <div className="p-1">
                <img
                  src={resourcesIllustration}
                  alt=""
                  className="rounded-t w-full"
                />
              </div>
              <div className="px-4 pt-4">
                <span className="text-secondary font-semibold text-xs mb-4">
                  #Projects
                </span>
                <p>
                  Streetwise Muslims is designed to engage and educate Muslims
                  to rekindle and scale their Islamic knowledge.
                </p>
              </div>
            </div>
            <div className="p-4 flex">
              <Button
                buttonText={"Watch videos"}
                otherStyles={"bg-black text-white"}
                buttonRole={"externalLink"}
                destination={"https://www.youtube.com/playlist?list=PLBDpImb7W8w7whGrzRgAOJsTPrzR01vFa"}
                icon={youtubeIcon}
              />
            </div>
          </div>
        </div>

        {/* Testimonial */}
        <div className="px-4 md:px-12">
          <div className="bg-black rounded grid grid-cols-1 lg:grid-cols-3 items-end text-white">
            <div className="lg:col-span-2 px-4 md:px-10 py-20 text-center lg:text-start">
              <span className="text-xs bg-white/10 p-3 rounded">
                Testimonial
              </span>
              <div className="mt-6 text-pretty text-lg font-bold ubuntu-font">
                Transforming Community Support with MosquePay.
              </div>
              <div className="text-secondary mt-2">
                Using MosquePay has revolutionized the way I raise funds for our
                community's needs. Each month, I run targeted fundraisers
                through the platform, and the response has been overwhelming.
                The ease and efficiency of MosquePay have allowed us to support
                various important causes, making a real difference in people's
                lives. I'm grateful for this tool that has empowered me to drive
                positive change and unite our community in giving.
              </div>
              <div>
                - <br />
                Marian Zaynab
              </div>
            </div>
            <div className="lg:col-span-1 px-4 flex justify-center">
              <img src={aiImage} alt="" />
            </div>
          </div>
        </div>

        {/* We've got you covered! */}
        <div className="px-4 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-4 items-center">
            <div className="h-full flex items-center">
              <div className="p-0 md:p-10 text-center lg:text-start">
                <p className="text-[24px] font-bold ubuntu-font">
                  We've got you covered!
                </p>
                <p className="mb-4 mt-2 text-[20px] text-secondary text-pretty">
                  With over{" "}
                  <span className="decoration-2 underline underline-offset-2 decoration-[#c4c4c480] text-black">
                    ₦{totalAmountRaised}
                  </span>{" "}
                  raised from{" "}
                  <span className="decoration-2 underline underline-offset-2 decoration-[#c4c4c480] text-black">
                    {totalDonations}
                  </span>{" "}
                  donations, Mosquepay is an effective platform for fundraising
                  humanitarian projects in Nigeria. With a simple interface and
                  a team of experts in your corner, you can raise money or make
                  donations with ease.
                </p>
                <div className="grid lg:flex justify-center lg:justify-start gap-4">
                  <Button
                    buttonRole={"custom"}
                    buttonText={"Create a campaign"}
                    otherStyles={"text-white bg-black"}
                    icon={add}
                    onClick={saveCreateCampaignClick}
                  />
                  <Link to={"/how-it-works"} className="text-sm font-medium py-6 px-8 md:p-4 rounded text-center decoration-2 underline underline-offset-4 decoration-[#c4c4c480]">
                    See how it works
                  </Link>
                </div>
              </div>
            </div>
            <div className="relative">
        <div className="aspect-square md:aspect-video w-full overflow-hidden rounded">
          <img
            src={videoThumbnail}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute top-0 bg-black/50 w-full h-full flex items-center justify-center rounded p-6">
          <div className="grid gap-1 justify-items-center">
            <Button
              buttonRole={"custom"}
              icon={play}
              buttonText={"Play video"}
              otherStyles={
                "bg-white text-black hover:bg-white/50 backdrop-blur-sm transition-all duration-500"
              }
              onClick={openModal}
            />
          </div>
        </div>
      </div>
      
      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm">
          <div className="relative aspect-video w-full md:w-[60%] mx-4">
            {/* Close button */}
            <button
              onClick={closeModal}
              className="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors z-10"
            >
              close
            </button>
            
            {/* Video container */}
            <div className="relative aspect-video w-full bg-black rounded-lg overflow-hidden">
              <iframe
                src={getYouTubeEmbedUrl("https://www.youtube.com/watch?v=ErheTfLZuyM")}
                title="YouTube video player"
                className="w-full h-full"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
          </div>
          
          {/* Click outside to close */}
          <div className="absolute inset-0 -z-10" onClick={closeModal}/>
        </div>
      )}
        </div>
        </div>

        {/* Schedule your donations */}
        <div className="px-4 md:px-12">
          <div className="grid lg:flex justify-between p-10 bg-grungePattern bg-top bg-repeat rounded text-white">
            <div className="w-full lg:w-[70%] text-center lg:text-start">
              <p className="text-pretty text-lg font-semibold">
                Schedule your donations!
              </p>
              <p className="text-secondary">
                Automating your donations ensures consistent support and allows
                us to allocate resources more effectively, enhancing the impact
                of your contributions.
              </p>
            </div>
            <div className="mt-6 flex justify-center">
              <Button
                buttonText={"Coming soon..."}
                otherStyles={"bg-white text-black"}
              />
            </div>
          </div>
        </div>

        {/* Frequently asked questions */}
        <div className="px-4 md:px-12">
          <Accordion />
        </div>

        {/* The HalalNest Show */}
        <div className="px-4 md:px-12 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="border rounded overflow-hidden">
            <img
              src={tvShowThumbnail}
              alt=""
              className="w-full aspect-video object-cover rounded-t"
            />
            <div className="p-4 md:p-6">
              <p className="text-pretty font-semibold">Halalnest show: Empowering Muslims with halal financial knowledge.</p>
              <p className="text-secondary mb-6">
                Welcome to the HalalNest Show — where faith meets wealth.
              </p>
              <Button
                buttonRole={"externalLink"}
                buttonText={"Watch episodes"}
                otherStyles={"text-white bg-black"}
                icon={youtubeIcon}
                destination={
                  "https://www.youtube.com/playlist?list=PLBDpImb7W8w720p9m42cIvyXi-rElRTzH"
                }
              />
            </div>
          </div>
          <div className="border rounded overflow-hidden">
            <img
              src={streetwise}
              alt=""
              className="w-full aspect-video object-cover rounded-t"
            />
            <div className="p-4 md:p-6">
              <p className="text-pretty font-semibold">Streetwise Muslim: Faith isn’t separate from life — it shapes it.</p>
              <p className="text-secondary mb-6">
                Streetwise Muslim explores how Islamic values guide us through each moment.
              </p>
              <Button
                buttonRole={"externalLink"}
                buttonText={"Watch episodes"}
                otherStyles={"text-white bg-black"}
                icon={youtubeIcon}
                destination={
                  "https://www.youtube.com/playlist?list=PLBDpImb7W8w4TmlhGvqe455LoZtdLxjSX"
                }
              />
            </div>
          </div>
        </div>

        {/* Quote */}
        <div className="px-4 md:px-12">
          <p className="text-center text-sm text-secondary font-semibold ubuntu-font">
            In the pursuit of goodness, even a small act of charity can make a
            big difference. <br />–<br />
            Prophet Muhammad (PBUH)
          </p>
        </div>

        <Footer />
      </div>
    );
}
 
export default Landing;